import styled from 'styled-components';
import { borderRadius, compose, height, padding, space, variant, width } from 'styled-system';
import { theme } from '../../essentials/theme';
import { get } from '../../utils/themeGet';
import { getSemanticValue } from '../../utils/cssVariables';
const levelVariant = variant({
    prop: 'level',
    variants: {
        0: {
            backgroundColor: getSemanticValue('background-page-default'),
            boxShadow: 'none'
        },
        100: {
            backgroundColor: getSemanticValue('background-page-elevation-1'),
            boxShadow: theme.shadows.small
        },
        200: {
            backgroundColor: getSemanticValue('background-page-elevation-2'),
            boxShadow: theme.shadows.medium
        },
        300: {
            backgroundColor: getSemanticValue('background-page-elevation-3'),
            boxShadow: theme.shadows.large
        }
    }
});
const Card = styled.div.attrs({ theme }).withConfig({ displayName: "Card", componentId: "sc-1b2ounj" }) `
    overflow: auto;
    box-sizing: border-box;
    border-radius: ${get('radii.1')};
    padding: ${get('space.5')};

    ${compose(levelVariant, borderRadius, height, space, width, padding)}
`;
export { Card };
